module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.35480640.eot";